class BESSAppTargetType {
    project = 0;
    building = 1;
    space = 2;
    buildingClass = 3;
    solarpv = 4;
    room = 5;
    rainwaterTank = 6;
}